import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { CtaButton } from '../ui/CtaButton';
import { withPlan, withoutPlan } from '../../data/comparison';
import { DELIVERY_NOTE } from '../../data/site';
export function FinalComparison() {
  return <section aria-labelledby="final-title" className="border-t border-line bg-mint py-20 text-ink lg:py-24" data-id="element-482" data-mp="3f0d81g7rhyti">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-483" data-mp="2raiwr333cibd">
        <SectionHeading id="final-title" eyebrow="Your choice" lead="Your next flag football unit:" highlight="two ways to start" data-id="element-484" data-mp="2mamv3ahv92yz" />

        <div className="mx-auto mt-12 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-485" data-mp="3082zkgglqmo3">
          <div className="rounded-xl border border-line bg-cream p-6 sm:p-8" data-id="element-486" data-mp="2w79ervyghnzf">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-body" data-id="element-487" data-mp="fj5er9tukqjk">Without a plan</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-488" data-mp="bi21mv36p8m1">
              {withoutPlan.map(item => <li key={item} className="flex gap-3 text-base text-body" data-id="element-489" data-mp="2uwuzbcgx853l">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-490" data-mp="2zvy1mp5inx7v">
                    <XIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-491" data-mp="33wi1i0hh5exp" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-xl border-2 border-gold bg-paperwhite p-6 sm:p-8" data-id="element-492" data-mp="2c523laagw5s6">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-gold-dark" data-id="element-493" data-mp="2g99wzkrve9wq">With Flag Football Class Ready</h3>
            <ul className="mt-6 space-y-3.5" data-id="element-494" data-mp="2pyjn4v35lii7">
              {withPlan.map(item => <li key={item} className="flex gap-3 text-base font-medium text-ink" data-id="element-495" data-mp="2q0eb6i9q1qqi">
                  <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-go text-ink" data-id="element-496" data-mp="1sh31soxvs8yw">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} data-id="element-497" data-mp="30smo96bm9bqo" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div id="final-cta" className="mx-auto mt-14 max-w-[576px] rounded-xl border border-line border-t-4 border-t-gold bg-paperwhite p-6 text-center sm:p-10" data-id="element-498" data-mp="39lq05a6m5gj7">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-gold-dark" data-id="element-499" data-mp="35m8vuk2xapfm">Full school year + 5 bonuses</p>
          <p className="mt-3 font-display font-bold leading-none text-ink" data-id="element-500" data-mp="2cvqt5k642q2q">
            <span className="text-[80px] sm:text-[96px]" data-id="element-501" data-mp="2cxjymw4zn495">$27</span>
            <span className="ml-2 align-top text-[26px]" data-id="element-502" data-mp="2qwjpmafz3v8h">USD</span>
          </p>
          <p className="mt-2 text-[13px] font-bold uppercase tracking-[0.16em] text-body" data-id="element-503" data-mp="2luub2ktjkzfn">Launch price · One-time payment</p>
          <CtaButton target="checkout" size="xl" className="mt-8 w-full" data-id="element-504" data-mp="62wr9aos5fvd">
            Continue to checkout
          </CtaButton>
          <p className="mt-6 text-base text-body" data-id="element-505" data-mp="9mosu3ue05c3">10-day money-back guarantee · {DELIVERY_NOTE}</p>
        </div>
      </div>
    </section>;
}